module.exports = __webpack_public_path__ + "static/media/safeauto-round@3x.dba57d42.png";